import request from '@/axios/index.js'
const account = '/customer/account/';

export function bindingAccountSelector(data) {
    return request.axios({
        url: account+'bindingAccountSelector'
    })
}
export function bindingAccountList(data,loading) {
    return request.axios({
        url: account+'bindingAccountList',
        data: data,
        loading:loading
    })
}
export function getCstBindingAccountNum(data,loading) {
    return request.axios({
        url: account+'getCstBindingAccountNum',
        data: data,
        loading:loading
    })
}
export function addBindingAccount(data,loading) {
    return request.axios({
        url: account+'addBindingAccount',
        data: data,
        loading:loading
    })
}
export function viewBindingAccount(data,loading) {
    return request.axios({
        url: account+'viewBindingAccount',
        data: data,
        loading:loading
    })
}
export function modifyBindingAccount(data,loading) {
    return request.axios({
        url: account+'modifyBindingAccount',
        data: data,
        loading:loading
    })
}
// 解绑
export function invalidBindingAccount(data,loading) {
    return request.axios({
        url: '/customer/account/invalidBindingAccount',
        data: data,
        loading:loading
    })
}


// WEBPACK FOOTER //
// ./src/api/customer.js